import React from 'react';

import styles from './troy.module.scss';
import { connectTo } from '../../utils';
import { Grid } from '../../components/common';

import {
  Payment,
  ContactBox,
  Timeline,
  PayNow,
  DemandTable,
  Greetings,
  DemandExplanation,
} from '../../components/home/index.troy';

import { PAYMENTS } from '../../constants/routes';

class HomePage extends React.Component {
  onPaymentClick = () => {
    const { history } = this.props;
    history.push(PAYMENTS);
  };

  render() {
    const {
      liabilityItems,
      timeline,
      paymentMethods,
      greetingsBlur,
      contactBoxBlur,
      payNowBlur,
      demandTableBlur,
      timelineBlur,
      demandExplanationBlur,
      paymentHide,
      greetingsHide,
      payNowHide,
      timelineHide,
      demandTableHide,
      contactBoxHide,
      absoluteDemandTableHide,
      balance,
      currency,
      liabilityStatementList,
      demandExplanationHide,
      liabilityLogo,
      liabilityStatus,
    } = this.props;
    return (
      <div className={styles['home__wrapper']}>
        <div className={styles['home__content']}>
          <Grid container direction="column" spacing={2}>
            {(!absoluteDemandTableHide && !demandTableHide && (
              <Grid item>
                <div className={styles['home__absolute-demand-table-wrapper']}>
                  <DemandTable
                    blur={demandTableBlur}
                    items={liabilityItems}
                    balance={balance}
                    currency={currency}
                    extended={liabilityStatementList}
                  />
                </div>
              </Grid>
            )) ||
              null}
            {((!payNowHide || (paymentMethods && paymentMethods.length)) && (
              <Grid item className={styles['home__paynow-payment']}>
                {!payNowHide && (
                  <div className={styles['home__paynow']}>
                    <PayNow
                      blur={payNowBlur}
                      onPaymentClick={this.onPaymentClick}
                    />
                  </div>
                )}
                {paymentMethods && paymentMethods.length ? (
                  <div className={styles['home__payment']}>
                    <Payment
                      blur={payNowBlur}
                      {...{ paymentMethods, paymentHide, balance }}
                    />
                  </div>
                ) : null}
              </Grid>
            )) ||
              null}
            {(absoluteDemandTableHide &&
              (!greetingsHide || !contactBoxHide) && (
                <Grid container item>
                  {!greetingsHide && (
                    <Grid md={!contactBoxHide ? 9 : 12} item>
                      <Greetings
                        blur={greetingsBlur}
                        clientLogo={liabilityLogo}
                      />
                    </Grid>
                  )}
                  {!contactBoxHide && (
                    <Grid
                      md={3}
                      item
                      className={styles['home__greetings-contact']}
                    >
                      <ContactBox blur={contactBoxBlur} link="/" />
                    </Grid>
                  )}
                </Grid>
              )) ||
              null}
            {(!demandExplanationHide && (
              <Grid item className={styles['home__demand-explanation-wrapper']}>
                <DemandExplanation blur={demandExplanationBlur} />
              </Grid>
            )) ||
              null}
            <Grid
              container
              className={styles['home__liability-info']}
              spacing={2}
              item
              justify="space-between"
            >
              {(!demandTableHide && (
                <Grid
                  md={4}
                  sm={5}
                  className={styles['home__demand-table']}
                  item
                >
                  <DemandTable
                    blur={demandTableBlur}
                    items={liabilityItems}
                    balance={balance}
                    currency={currency}
                    extended={liabilityStatementList}
                  />
                </Grid>
              )) ||
                null}
              {(!timelineHide && (
                <Grid md={8} sm={7} className={styles['home__timeline']} item>
                  <Timeline
                    blur={timelineBlur}
                    items={timeline}
                    liabilityStatus={liabilityStatus}
                  />
                </Grid>
              )) ||
                null}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    liability: { liabilityItems, timeline, logo, liabilityStatus },
    payment: {
      paymentUserInfo: { totalBalance, dueCurrency },
    },
    ui: {
      home: {
        liabilityStatementList,
        blur: {
          greetings: greetingsBlur,
          contactBox: contactBoxBlur,
          payNow: payNowBlur,
          demandTable: demandTableBlur,
          timeline: timelineBlur,
          demandExplanation: demandExplanationBlur,
        },
        hide: {
          greetings: greetingsHide,
          contactBox: contactBoxHide,
          payNow: payNowHide,
          timeline: timelineHide,
          demandTable: demandTableHide,
          absoluteDemandTable: absoluteDemandTableHide,
          demandExplanation: demandExplanationHide,
        },
      },
      payment: { methods: paymentMethods, hide: paymentHide },
    },
    profile: { firstname, lastname },
  }) => ({
    liabilityItems,
    liabilityStatus,
    timeline,
    paymentMethods,
    greetingsBlur,
    contactBoxBlur,
    payNowBlur,
    demandTableBlur,
    timelineBlur,
    demandExplanationBlur,
    paymentHide,
    greetingsHide,
    payNowHide,
    timelineHide,
    demandTableHide,
    contactBoxHide,
    absoluteDemandTableHide,
    firstName: firstname,
    lastName: lastname,
    balance: totalBalance,
    currency: dueCurrency,
    liabilityStatementList,
    demandExplanationHide,
    liabilityLogo: logo,
  }),
  {},
  HomePage
);
